import { useEffect } from "react";

import { useAppDispatch } from "../../app/hooks";
import { AclPath, meteringPowerAndGasAclPath } from "../../config/constants";
import { useGetAclMeByPathStringQuery } from "../../features/artesian/artesianApi";
import { setPageRoles } from "../../store/permissionSlice";

export const useFetchAclRolesForPaths = () => {
  const dispatch = useAppDispatch();

  const expectation = useGetAclMeByPathStringQuery({ path: AclPath.Expectation });
  const timetransform = useGetAclMeByPathStringQuery({ path: AclPath.TimeTransform });
  const filter = useGetAclMeByPathStringQuery({ path: AclPath.Filter });
  const apikey = useGetAclMeByPathStringQuery({ path: AclPath.ApiKey });
  const gmepublicoffer = useGetAclMeByPathStringQuery({ path: AclPath.GmePublicOffer });
  const principalGroup = useGetAclMeByPathStringQuery({ path: AclPath.PrincipalGroup });
  const meteringPowerAndGas = useGetAclMeByPathStringQuery({ path: meteringPowerAndGasAclPath });
  
  useEffect(() => {
    [expectation, timetransform, filter, apikey, gmepublicoffer, principalGroup, meteringPowerAndGas].forEach(query => {
      if (query.isSuccess && query.data) {
        query.data.forEach(({ Path, Roles }) => {
          dispatch(setPageRoles({ path: Path, roles: Roles.map(r => r.Role) }));
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    expectation.isSuccess,
    expectation.data,
    timetransform.isSuccess,
    timetransform.data,
    filter.isSuccess,
    filter.data,
    apikey.isSuccess,
    apikey.data,
    gmepublicoffer.isSuccess,
    gmepublicoffer.data,
    principalGroup.isSuccess,
    principalGroup.data,
    meteringPowerAndGas.isSuccess,
    meteringPowerAndGas.data,
  ]);
};
